const premiumData = [
  {
    id: "Premium Sale",
    data: [
      { x: 1, y: 5 },
      { x: 2, y: 11 },
      { x: 3, y: 12 },
      { x: 4, y: 13 },
      { x: 5, y: 12 },
      { x: 6, y: 18 },
      { x: 7, y: 16 },
      { x: 8, y: 8 },
      { x: 9, y: 10 },
      { x: 10, y: 9 },
      { x: 11, y: 9 },
      { x: 12, y: 9 },
    ],
  },
];

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const CITIES = [
  { id: 1, name: "New Delhi", code: "newDelhi" },
  { id: 2, name: "Banglore City", code: "bangloreCity" },
  { id: 3, name: "Mumbai", code: "mumbai" },
  { id: 4, name: "Kolkata", code: "kolkata" },
  { id: 5, name: "Pune", code: "pune" },
];

const ISSUED_CERTIFICATE_BY_CITY: Record<string, any> = {
  newDelhi: [
    { month: 1, count: 40 },
    { month: 2, count: 36 },
    { month: 3, count: 61 },
    { month: 4, count: 27 },
    { month: 5, count: 48 },
    { month: 6, count: 57 },
    { month: 7, count: 19 },
    { month: 8, count: 11 },
    { month: 9, count: 24 },
    { month: 10, count: 44 },
    { month: 11, count: 52 },
    { month: 12, count: 38 },
  ],
  bangloreCity: [
    { month: 1, count: 30 },
    { month: 2, count: 26 },
    { month: 3, count: 51 },
    { month: 4, count: 17 },
    { month: 5, count: 58 },
    { month: 6, count: 47 },
    { month: 7, count: 29 },
    { month: 8, count: 31 },
    { month: 9, count: 14 },
    { month: 10, count: 54 },
    { month: 11, count: 62 },
    { month: 12, count: 18 },
  ],
  dubai: [
    { month: 1, count: 20 },
    { month: 2, count: 66 },
    { month: 3, count: 61 },
    { month: 4, count: 17 },
    { month: 5, count: 28 },
    { month: 6, count: 47 },
    { month: 7, count: 39 },
    { month: 8, count: 21 },
    { month: 9, count: 34 },
    { month: 10, count: 54 },
    { month: 11, count: 22 },
    { month: 12, count: 32 },
  ],
};

const PREMIUM_BY_CITY: Record<string, any> = {
  newDelhi: [
    { month: 1, count: 40 },
    { month: 2, count: 60 },
    { month: 3, count: 120 },
    { month: 4, count: 60 },
    { month: 5, count: 90 },
    { month: 6, count: 89 },
    { month: 7, count: 115 },
    { month: 8, count: 157 },
    { month: 9, count: 180 },
    { month: 10, count: 120 },
    { month: 11, count: 85 },
    { month: 12, count: 93 },
  ],

  bangloreCity: [
    { month: 1, count: 20 },
    { month: 2, count: 60 },
    { month: 3, count: 40 },
    { month: 4, count: 70 },
    { month: 5, count: 10 },
    { month: 6, count: 189 },
    { month: 7, count: 15 },
    { month: 8, count: 157 },
    { month: 9, count: 80 },
    { month: 10, count: 20 },
    { month: 11, count: 85 },
    { month: 12, count: 53 },
  ],
  dubai: [
    { month: 1, count: 140 },
    { month: 2, count: 160 },
    { month: 3, count: 20 },
    { month: 4, count: 60 },
    { month: 5, count: 10 },
    { month: 6, count: 89 },
    { month: 7, count: 15 },
    { month: 8, count: 57 },
    { month: 9, count: 80 },
    { month: 10, count: 20 },
    { month: 11, count: 185 },
    { month: 12, count: 93 },
  ],
};

export {
  premiumData,
  MONTHS,
  CITIES,
  ISSUED_CERTIFICATE_BY_CITY,
  PREMIUM_BY_CITY,
};
